import badWords from "./BadWords.json";

export function WordFilter(text) {
  if (!text) return false;

  const lower = text.toLowerCase();

  const hasBadWord = badWords.some((word) => {
    const pattern = word
      .split("")
      .map((c) => `${c}[^\uAC00-\uD7A3]*`)
      .join("");
    const regex = new RegExp(pattern, "i");
    return regex.test(lower);
  });
  if (hasBadWord) return true;

  const repeatedPattern = /([^\s])\1{4,}/;
  if (repeatedPattern.test(text)) return true;

  return false;
}
